import EndPointConfig from '../../models/api/endPointConfig';

const controller = 'Faqs';

/// Define all EndPoints for contact section.
export const FaqsEP: EndPointConfig[] = [
    // Envio de formulario a la API

    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)
        .setAlias('GetFaqs'),

    new EndPointConfig()
        .setMethod('POST')
        .setController(controller)
        .setAlias('CreateFaq'),

    new EndPointConfig()
        .setMethod('PATCH')
        .setController(controller)
        .setAlias('UpdateFaq'),

    new EndPointConfig()
        .setMethod('PATCH')
        .setController(controller)
        .setActionName('order')
        .setAlias('ChangeOrderFaqs'),

    new EndPointConfig()
        .setMethod('DELETE')
        .setController(controller)
        .setPattern('{id}')
        .setAlias('DeleteFaq')
];